import { DataBean } from "../DataBean";

export class AgencyUser extends DataBean {



    public async deleteAgencyUser(idAgencyUser: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteAgencyUser_Number", [idAgencyUser]);
    }

    public async addAgencyUser(idAgencyRole: any, idAccount: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.AgencyUser_addAgencyUser_Number_Number_Number", [idAgencyRole, idAccount, idEmployee]);
    }

    public async getAgencyUserCatalog(idAgencyRole: any, idAccount: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getAgencyUserCatalog_Number_Number_Number_Number", [idAgencyRole, idAccount, page, recordsPerPage]);
    }

}